import { useState, useEffect } from "react"
import logo from "../images/brand/mainlogo.png";
import { Link, useNavigate, useLocation } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faArrowRight } from '@fortawesome/free-solid-svg-icons'

function Account() {
  const [location, setLocation] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.location.href = "https://optiglobalcapital.com/account";
  }, []);

  useEffect(() => {
    const lsType = state?.location;
    if (!lsType) {
      setLocation("login");
    } else {
      setLocation(lsType);
    }
  }, [state, navigate]);

  return (
    <div className="min-vh-100 d-flex flex-column text-white" style={{backgroundColor: 'rgb(5, 8, 11)', padding: '0px 32px 144px'}}>
      <header className="d-flex align-items-center justify-content-between" style={{padding: '32px 0px'}}>
        <img src={logo} alt="logo" className="app-logo"/>
        <Link to="/" className="text-light text-decoration-none" style={{fontSize: '14px'}}>
          Back to homepage
        </Link>
      </header>
      <main className="flex-grow-1 d-flex justify-content-center p-md-3 mt-md-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
                <p className="mb-2 text-uppercase" style={{fontSize:'20px',fontWeight:'900'}}>Select Account Type</p>
                <div className="bg-prime" style={{height:'4px', width:'30px'}}></div>
                <div className="row justify-content-center">
                    <div className="col-md-6 g-5">
                        <a href={`https://retirement.optiglobalcapital.com/${location}`} className="mycard noLink dark-card" style={{ backgroundImage: 'url(/uploads/401k.jpg)' }}>
                            <div className="dark-overlay"></div>
                            <img className="mb-2 " src={`/uploads/saving.png`} alt="chart" style={{width:'70px'}}/>
                            <p className="fw-bold mb-0 text-white">
                                401(k) Retirement
                            </p>
                        </a>
                    </div>
                    <div className="col-md-6 g-5">
                        <a href={`https://optiglobalcapital.com/${location}`} className="mycard noLink dark-card" style={{ backgroundImage: 'url(/uploads/trading.jpg)' }}>
                            <div className="dark-overlay"></div>
                            <img className="mb-2 " src={`/uploads/money-exchange.png`} alt="chart" style={{width:'70px'}}/>
                            <p className="fw-bold mb-0 text-white">
                                Crypto Day Trading
                            </p>
                        </a>
                    </div>
                    <div className="col-md-6 g-5">
                        <a href={`https://stock.optiglobalcapital.com/${location}`} className="mycard noLink dark-card" style={{ backgroundImage: 'url(/uploads/stock.png)' }}>
                            <div className="dark-overlay"></div>
                            <img className="mb-2 " src={`/uploads/clearance.png`} alt="chart" style={{width:'70px'}}/>
                            <p className="fw-bold mb-0 text-white">
                                Stock Market
                            </p>
                        </a>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-center mt-5" style={{gap:'5px'}}>
                    <Link to="/" className="rounded-pill px-5 py-2 fw-semibold mycard shadow-sm noLink">Back</Link>
                    <Link to="/" className="rounded-circle fw-semibold bg-prime shadow-sm noLink d-flex align-items-center justify-content-center" style={{width:'40px',height:'40px'}}>
                        <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '20px'}} className="lh-1" />
                    </Link>
                </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Account